module.exports = __webpack_public_path__ + "img/master-title.c4667434.png";